import { ProjectFollowUpAction } from "#app/components/updates/project-follow-up-action";
import { useIssueViewCapabilities } from "#app/components/issue-view/issue-view-capabilities";
import { useWorkspaceData } from "#app/lib/data/workspace-data-provider";
import { effectiveProjectCycle } from "#app/lib/project-updates";
import { useIssueWidgetContext } from "#app/widgets/issue/issue-widget-context";

/** The Follow up section's shortcut to the detail header's "Update" — outline
 * rung, summoned with the header's other chrome on hover and standing on a
 * coarse pointer (the stack header's rule). The header verb stays the one
 * standing copy; this one saves the pointer a trip while it is already on the
 * section, so it exists only while there is a clock to update: with updates
 * off the section IS the Start row. The capability context gates it by
 * direct path, the same seam the widget's own Cycle picker reads. */
export function IssueUpdatesHeaderActions() {
  const ctx = useIssueWidgetContext();
  const { canEdit } = useIssueViewCapabilities();
  const { stageMap, workflowMap } = useWorkspaceData();
  const issue = ctx.issue;
  if (!issue) return null;
  const stage = ctx.stage ?? stageMap.get(issue.stageId) ?? null;
  const running =
    effectiveProjectCycle(issue.age, stage, workflowMap.get(issue.workflowId) ?? null)
      .cycle != null;
  if (!running) return null;
  return (
    <ProjectFollowUpAction
      editable={canEdit}
      issue={issue}
      stage={stage}
      variant="outline"
    />
  );
}
